import { request } from '@tencent/ppd-base-libs';

/** 获取双钱包中转页跳转配置
 * 配置地址：https://huoyuan-wphk.woa.com/config/?isWhiteHuo=1#/showConfig/mpRedirectMerchantConf
 */
export function getJumpConfig() {
  return request.loadConfig('https://st.moneydata.hk/res/cc/mpRedirectMerchantConf/config.json');
}
